import { accessToken } from './accessToken';
import type { AccessToken } from './tokenSlice';

export const prepareHeaders = (headers: Headers) => {
    // const token = 'ACCES_TOKEN'; // Insert token and change url in monitorApi.ts to test against local server
    const token = accessToken.getAccessToken() as AccessToken;
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
    }
    return headers;
};
